// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"f1d5a749","364":"8cb0ad06","455":"ec0ada3a","880":"e3081575","885":"39dcddd3"}[chunkId] + ".chunk.css";
};